<script>
  import { onMount } from 'svelte';

  let numbers = [];
  let loading = true;

  onMount(async () => {
    const proxyUrl = 'https://corsproxy.io/?';
    const targetUrl = 'https://feeds.soundcloud.com/users/soundcloud:users:424810788/sounds.rss';
    
    try {
      const response = await fetch(proxyUrl + targetUrl);
      const text = await response.text();
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(text, 'text/xml');

      const enclosures = xmlDoc.getElementsByTagName('enclosure');
      for (let i = 0; (i < enclosures.length && i < 5); i++) {
        const url = enclosures[i].getAttribute('url');
        const match = url.match(/\/stream\/(\d+)-user-/);
        if (match && match[1]) {
          numbers.push(match[1]);
        }
      }
    } catch (error) {
      console.error('Error fetching RSS feed:', error);
    } finally {
      loading = false;
    }
  });
</script>

{#if loading}
  <p>Loading...</p>
{:else}
  {#each numbers as ID}
  <div class="player-container">
    <iframe width="100%" height="166" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/{ID}&color=%23f7931e&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false"></iframe>
  </div>
  {/each}
{/if}

<style>
.player-container {
  padding: 7px 0 7px 0;
}
</style>